module.exports = __webpack_public_path__ + "media/images/flags/4x3/zwe-e72628996a34639285937a6bf18873fb.svg";